// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { GetAlliancesData, GetAlliancesResponses, GetAlliancesErrors, GetAlliancesAllianceIdData, GetAlliancesAllianceIdResponses, GetAlliancesAllianceIdErrors, GetAlliancesAllianceIdContactsData, GetAlliancesAllianceIdContactsResponses, GetAlliancesAllianceIdContactsErrors, GetAlliancesAllianceIdContactsLabelsData, GetAlliancesAllianceIdContactsLabelsResponses, GetAlliancesAllianceIdContactsLabelsErrors, GetAlliancesAllianceIdCorporationsData, GetAlliancesAllianceIdCorporationsResponses, GetAlliancesAllianceIdCorporationsErrors, GetAlliancesAllianceIdIconsData, GetAlliancesAllianceIdIconsResponses, GetAlliancesAllianceIdIconsErrors, PostCharactersAffiliationData, PostCharactersAffiliationResponses, PostCharactersAffiliationErrors, GetCharactersCharacterIdData, GetCharactersCharacterIdResponses, GetCharactersCharacterIdErrors, GetCharactersCharacterIdAgentsResearchData, GetCharactersCharacterIdAgentsResearchResponses, GetCharactersCharacterIdAgentsResearchErrors, GetCharactersCharacterIdAssetsData, GetCharactersCharacterIdAssetsResponses, GetCharactersCharacterIdAssetsErrors, PostCharactersCharacterIdAssetsLocationsData, PostCharactersCharacterIdAssetsLocationsResponses, PostCharactersCharacterIdAssetsLocationsErrors, PostCharactersCharacterIdAssetsNamesData, PostCharactersCharacterIdAssetsNamesResponses, PostCharactersCharacterIdAssetsNamesErrors, GetCharactersCharacterIdAttributesData, GetCharactersCharacterIdAttributesResponses, GetCharactersCharacterIdAttributesErrors, GetCharactersCharacterIdBlueprintsData, GetCharactersCharacterIdBlueprintsResponses, GetCharactersCharacterIdBlueprintsErrors, GetCharactersCharacterIdCalendarData, GetCharactersCharacterIdCalendarResponses, GetCharactersCharacterIdCalendarErrors, GetCharactersCharacterIdCalendarEventIdData, GetCharactersCharacterIdCalendarEventIdResponses, GetCharactersCharacterIdCalendarEventIdErrors, PutCharactersCharacterIdCalendarEventIdData, PutCharactersCharacterIdCalendarEventIdResponses, PutCharactersCharacterIdCalendarEventIdErrors, GetCharactersCharacterIdCalendarEventIdAttendeesData, GetCharactersCharacterIdCalendarEventIdAttendeesResponses, GetCharactersCharacterIdCalendarEventIdAttendeesErrors, GetCharactersCharacterIdClonesData, GetCharactersCharacterIdClonesResponses, GetCharactersCharacterIdClonesErrors, DeleteCharactersCharacterIdContactsData, DeleteCharactersCharacterIdContactsResponses, DeleteCharactersCharacterIdContactsErrors, GetCharactersCharacterIdContactsData, GetCharactersCharacterIdContactsResponses, GetCharactersCharacterIdContactsErrors, PostCharactersCharacterIdContactsData, PostCharactersCharacterIdContactsResponses, PostCharactersCharacterIdContactsErrors, PutCharactersCharacterIdContactsData, PutCharactersCharacterIdContactsResponses, PutCharactersCharacterIdContactsErrors, GetCharactersCharacterIdContactsLabelsData, GetCharactersCharacterIdContactsLabelsResponses, GetCharactersCharacterIdContactsLabelsErrors, GetCharactersCharacterIdContractsData, GetCharactersCharacterIdContractsResponses, GetCharactersCharacterIdContractsErrors, GetCharactersCharacterIdContractsContractIdBidsData, GetCharactersCharacterIdContractsContractIdBidsResponses, GetCharactersCharacterIdContractsContractIdBidsErrors, GetCharactersCharacterIdContractsContractIdItemsData, GetCharactersCharacterIdContractsContractIdItemsResponses, GetCharactersCharacterIdContractsContractIdItemsErrors, GetCharactersCharacterIdCorporationhistoryData, GetCharactersCharacterIdCorporationhistoryResponses, GetCharactersCharacterIdCorporationhistoryErrors, PostCharactersCharacterIdCspaData, PostCharactersCharacterIdCspaResponses, PostCharactersCharacterIdCspaErrors, GetCharactersCharacterIdFatigueData, GetCharactersCharacterIdFatigueResponses, GetCharactersCharacterIdFatigueErrors, GetCharactersCharacterIdFittingsData, GetCharactersCharacterIdFittingsResponses, GetCharactersCharacterIdFittingsErrors, PostCharactersCharacterIdFittingsData, PostCharactersCharacterIdFittingsResponses, PostCharactersCharacterIdFittingsErrors, DeleteCharactersCharacterIdFittingsFittingIdData, DeleteCharactersCharacterIdFittingsFittingIdResponses, DeleteCharactersCharacterIdFittingsFittingIdErrors, GetCharactersCharacterIdFleetData, GetCharactersCharacterIdFleetResponses, GetCharactersCharacterIdFleetErrors, GetCharactersCharacterIdFwStatsData, GetCharactersCharacterIdFwStatsResponses, GetCharactersCharacterIdFwStatsErrors, GetCharactersCharacterIdImplantsData, GetCharactersCharacterIdImplantsResponses, GetCharactersCharacterIdImplantsErrors, GetCharactersCharacterIdIndustryJobsData, GetCharactersCharacterIdIndustryJobsResponses, GetCharactersCharacterIdIndustryJobsErrors, GetCharactersCharacterIdKillmailsRecentData, GetCharactersCharacterIdKillmailsRecentResponses, GetCharactersCharacterIdKillmailsRecentErrors, GetCharactersCharacterIdLocationData, GetCharactersCharacterIdLocationResponses, GetCharactersCharacterIdLocationErrors, GetCharactersCharacterIdLoyaltyPointsData, GetCharactersCharacterIdLoyaltyPointsResponses, GetCharactersCharacterIdLoyaltyPointsErrors, GetCharactersCharacterIdMailData, GetCharactersCharacterIdMailResponses, GetCharactersCharacterIdMailErrors, PostCharactersCharacterIdMailData, PostCharactersCharacterIdMailResponses, PostCharactersCharacterIdMailErrors, GetCharactersCharacterIdMailLabelsData, GetCharactersCharacterIdMailLabelsResponses, GetCharactersCharacterIdMailLabelsErrors, PostCharactersCharacterIdMailLabelsData, PostCharactersCharacterIdMailLabelsResponses, PostCharactersCharacterIdMailLabelsErrors, DeleteCharactersCharacterIdMailLabelsLabelIdData, DeleteCharactersCharacterIdMailLabelsLabelIdResponses, DeleteCharactersCharacterIdMailLabelsLabelIdErrors, GetCharactersCharacterIdMailListsData, GetCharactersCharacterIdMailListsResponses, GetCharactersCharacterIdMailListsErrors, DeleteCharactersCharacterIdMailMailIdData, DeleteCharactersCharacterIdMailMailIdResponses, DeleteCharactersCharacterIdMailMailIdErrors, GetCharactersCharacterIdMailMailIdData, GetCharactersCharacterIdMailMailIdResponses, GetCharactersCharacterIdMailMailIdErrors, PutCharactersCharacterIdMailMailIdData, PutCharactersCharacterIdMailMailIdResponses, PutCharactersCharacterIdMailMailIdErrors, GetCharactersCharacterIdMedalsData, GetCharactersCharacterIdMedalsResponses, GetCharactersCharacterIdMedalsErrors, GetCharactersCharacterIdMiningData, GetCharactersCharacterIdMiningResponses, GetCharactersCharacterIdMiningErrors, GetCharactersCharacterIdNotificationsData, GetCharactersCharacterIdNotificationsResponses, GetCharactersCharacterIdNotificationsErrors, GetCharactersCharacterIdNotificationsContactsData, GetCharactersCharacterIdNotificationsContactsResponses, GetCharactersCharacterIdNotificationsContactsErrors, GetCharactersCharacterIdOnlineData, GetCharactersCharacterIdOnlineResponses, GetCharactersCharacterIdOnlineErrors, GetCharactersCharacterIdOrdersData, GetCharactersCharacterIdOrdersResponses, GetCharactersCharacterIdOrdersErrors, GetCharactersCharacterIdOrdersHistoryData, GetCharactersCharacterIdOrdersHistoryResponses, GetCharactersCharacterIdOrdersHistoryErrors, GetCharactersCharacterIdPlanetsData, GetCharactersCharacterIdPlanetsResponses, GetCharactersCharacterIdPlanetsErrors, GetCharactersCharacterIdPlanetsPlanetIdData, GetCharactersCharacterIdPlanetsPlanetIdResponses, GetCharactersCharacterIdPlanetsPlanetIdErrors, GetCharactersCharacterIdPortraitData, GetCharactersCharacterIdPortraitResponses, GetCharactersCharacterIdPortraitErrors, GetCharactersCharacterIdRolesData, GetCharactersCharacterIdRolesResponses, GetCharactersCharacterIdRolesErrors, GetCharactersCharacterIdSearchData, GetCharactersCharacterIdSearchResponses, GetCharactersCharacterIdSearchErrors, GetCharactersCharacterIdShipData, GetCharactersCharacterIdShipResponses, GetCharactersCharacterIdShipErrors, GetCharactersCharacterIdSkillqueueData, GetCharactersCharacterIdSkillqueueResponses, GetCharactersCharacterIdSkillqueueErrors, GetCharactersCharacterIdSkillsData, GetCharactersCharacterIdSkillsResponses, GetCharactersCharacterIdSkillsErrors, GetCharactersCharacterIdStandingsData, GetCharactersCharacterIdStandingsResponses, GetCharactersCharacterIdStandingsErrors, GetCharactersCharacterIdTitlesData, GetCharactersCharacterIdTitlesResponses, GetCharactersCharacterIdTitlesErrors, GetCharactersCharacterIdWalletData, GetCharactersCharacterIdWalletResponses, GetCharactersCharacterIdWalletErrors, GetCharactersCharacterIdWalletJournalData, GetCharactersCharacterIdWalletJournalResponses, GetCharactersCharacterIdWalletJournalErrors, GetCharactersCharacterIdWalletTransactionsData, GetCharactersCharacterIdWalletTransactionsResponses, GetCharactersCharacterIdWalletTransactionsErrors, GetContractsPublicBidsContractIdData, GetContractsPublicBidsContractIdResponses, GetContractsPublicItemsContractIdData, GetContractsPublicItemsContractIdResponses, GetContractsPublicRegionIdData, GetContractsPublicRegionIdResponses, GetContractsPublicRegionIdErrors, GetCorporationCorporationIdMiningExtractionsData, GetCorporationCorporationIdMiningExtractionsResponses, GetCorporationCorporationIdMiningExtractionsErrors, GetCorporationCorporationIdMiningObserversData, GetCorporationCorporationIdMiningObserversResponses, GetCorporationCorporationIdMiningObserversErrors, GetCorporationCorporationIdMiningObserversObserverIdData, GetCorporationCorporationIdMiningObserversObserverIdResponses, GetCorporationCorporationIdMiningObserversObserverIdErrors, GetCorporationsNpccorpsData, GetCorporationsNpccorpsResponses, GetCorporationsNpccorpsErrors, GetCorporationsCorporationIdData, GetCorporationsCorporationIdResponses, GetCorporationsCorporationIdErrors, GetCorporationsCorporationIdAlliancehistoryData, GetCorporationsCorporationIdAlliancehistoryResponses, GetCorporationsCorporationIdAlliancehistoryErrors, GetCorporationsCorporationIdAssetsData, GetCorporationsCorporationIdAssetsResponses, GetCorporationsCorporationIdAssetsErrors, PostCorporationsCorporationIdAssetsLocationsData, PostCorporationsCorporationIdAssetsLocationsResponses, PostCorporationsCorporationIdAssetsLocationsErrors, PostCorporationsCorporationIdAssetsNamesData, PostCorporationsCorporationIdAssetsNamesResponses, PostCorporationsCorporationIdAssetsNamesErrors, GetCorporationsCorporationIdBlueprintsData, GetCorporationsCorporationIdBlueprintsResponses, GetCorporationsCorporationIdBlueprintsErrors, GetCorporationsCorporationIdContactsData, GetCorporationsCorporationIdContactsResponses, GetCorporationsCorporationIdContactsErrors, GetCorporationsCorporationIdContactsLabelsData, GetCorporationsCorporationIdContactsLabelsResponses, GetCorporationsCorporationIdContactsLabelsErrors, GetCorporationsCorporationIdContainersLogsData, GetCorporationsCorporationIdContainersLogsResponses, GetCorporationsCorporationIdContainersLogsErrors, GetCorporationsCorporationIdContractsData, GetCorporationsCorporationIdContractsResponses, GetCorporationsCorporationIdContractsErrors, GetCorporationsCorporationIdContractsContractIdBidsData, GetCorporationsCorporationIdContractsContractIdBidsResponses, GetCorporationsCorporationIdContractsContractIdBidsErrors, GetCorporationsCorporationIdContractsContractIdItemsData, GetCorporationsCorporationIdContractsContractIdItemsResponses, GetCorporationsCorporationIdContractsContractIdItemsErrors, GetCorporationsCorporationIdCustomsOfficesData, GetCorporationsCorporationIdCustomsOfficesResponses, GetCorporationsCorporationIdCustomsOfficesErrors, GetCorporationsCorporationIdDivisionsData, GetCorporationsCorporationIdDivisionsResponses, GetCorporationsCorporationIdDivisionsErrors, GetCorporationsCorporationIdFacilitiesData, GetCorporationsCorporationIdFacilitiesResponses, GetCorporationsCorporationIdFacilitiesErrors, GetCorporationsCorporationIdFwStatsData, GetCorporationsCorporationIdFwStatsResponses, GetCorporationsCorporationIdFwStatsErrors, GetCorporationsCorporationIdIconsData, GetCorporationsCorporationIdIconsResponses, GetCorporationsCorporationIdIconsErrors, GetCorporationsCorporationIdIndustryJobsData, GetCorporationsCorporationIdIndustryJobsResponses, GetCorporationsCorporationIdIndustryJobsErrors, GetCorporationsCorporationIdKillmailsRecentData, GetCorporationsCorporationIdKillmailsRecentResponses, GetCorporationsCorporationIdKillmailsRecentErrors, GetCorporationsCorporationIdMedalsData, GetCorporationsCorporationIdMedalsResponses, GetCorporationsCorporationIdMedalsErrors, GetCorporationsCorporationIdMedalsIssuedData, GetCorporationsCorporationIdMedalsIssuedResponses, GetCorporationsCorporationIdMedalsIssuedErrors, GetCorporationsCorporationIdMembersData, GetCorporationsCorporationIdMembersResponses, GetCorporationsCorporationIdMembersErrors, GetCorporationsCorporationIdMembersLimitData, GetCorporationsCorporationIdMembersLimitResponses, GetCorporationsCorporationIdMembersLimitErrors, GetCorporationsCorporationIdMembersTitlesData, GetCorporationsCorporationIdMembersTitlesResponses, GetCorporationsCorporationIdMembersTitlesErrors, GetCorporationsCorporationIdMembertrackingData, GetCorporationsCorporationIdMembertrackingResponses, GetCorporationsCorporationIdMembertrackingErrors, GetCorporationsCorporationIdOrdersData, GetCorporationsCorporationIdOrdersResponses, GetCorporationsCorporationIdOrdersErrors, GetCorporationsCorporationIdOrdersHistoryData, GetCorporationsCorporationIdOrdersHistoryResponses, GetCorporationsCorporationIdOrdersHistoryErrors, GetCorporationsProjectsListingData, GetCorporationsProjectsListingResponses, GetCorporationsProjectsListingErrors, GetCorporationsProjectsDetailData, GetCorporationsProjectsDetailResponses, GetCorporationsProjectsDetailErrors, GetCorporationsProjectsContributionData, GetCorporationsProjectsContributionResponses, GetCorporationsProjectsContributionErrors, GetCorporationsProjectsContributorsData, GetCorporationsProjectsContributorsResponses, GetCorporationsProjectsContributorsErrors, GetCorporationsCorporationIdRolesData, GetCorporationsCorporationIdRolesResponses, GetCorporationsCorporationIdRolesErrors, GetCorporationsCorporationIdRolesHistoryData, GetCorporationsCorporationIdRolesHistoryResponses, GetCorporationsCorporationIdRolesHistoryErrors, GetCorporationsCorporationIdShareholdersData, GetCorporationsCorporationIdShareholdersResponses, GetCorporationsCorporationIdShareholdersErrors, GetCorporationsCorporationIdStandingsData, GetCorporationsCorporationIdStandingsResponses, GetCorporationsCorporationIdStandingsErrors, GetCorporationsCorporationIdStarbasesData, GetCorporationsCorporationIdStarbasesResponses, GetCorporationsCorporationIdStarbasesErrors, GetCorporationsCorporationIdStarbasesStarbaseIdData, GetCorporationsCorporationIdStarbasesStarbaseIdResponses, GetCorporationsCorporationIdStarbasesStarbaseIdErrors, GetCorporationsCorporationIdStructuresData, GetCorporationsCorporationIdStructuresResponses, GetCorporationsCorporationIdStructuresErrors, GetCorporationsCorporationIdTitlesData, GetCorporationsCorporationIdTitlesResponses, GetCorporationsCorporationIdTitlesErrors, GetCorporationsCorporationIdWalletsData, GetCorporationsCorporationIdWalletsResponses, GetCorporationsCorporationIdWalletsErrors, GetCorporationsCorporationIdWalletsDivisionJournalData, GetCorporationsCorporationIdWalletsDivisionJournalResponses, GetCorporationsCorporationIdWalletsDivisionJournalErrors, GetCorporationsCorporationIdWalletsDivisionTransactionsData, GetCorporationsCorporationIdWalletsDivisionTransactionsResponses, GetCorporationsCorporationIdWalletsDivisionTransactionsErrors, GetDogmaAttributesData, GetDogmaAttributesResponses, GetDogmaAttributesErrors, GetDogmaAttributesAttributeIdData, GetDogmaAttributesAttributeIdResponses, GetDogmaAttributesAttributeIdErrors, GetDogmaDynamicItemsTypeIdItemIdData, GetDogmaDynamicItemsTypeIdItemIdResponses, GetDogmaDynamicItemsTypeIdItemIdErrors, GetDogmaEffectsData, GetDogmaEffectsResponses, GetDogmaEffectsErrors, GetDogmaEffectsEffectIdData, GetDogmaEffectsEffectIdResponses, GetDogmaEffectsEffectIdErrors, GetFleetsFleetIdData, GetFleetsFleetIdResponses, GetFleetsFleetIdErrors, PutFleetsFleetIdData, PutFleetsFleetIdResponses, PutFleetsFleetIdErrors, GetFleetsFleetIdMembersData, GetFleetsFleetIdMembersResponses, GetFleetsFleetIdMembersErrors, PostFleetsFleetIdMembersData, PostFleetsFleetIdMembersResponses, PostFleetsFleetIdMembersErrors, DeleteFleetsFleetIdMembersMemberIdData, DeleteFleetsFleetIdMembersMemberIdResponses, DeleteFleetsFleetIdMembersMemberIdErrors, PutFleetsFleetIdMembersMemberIdData, PutFleetsFleetIdMembersMemberIdResponses, PutFleetsFleetIdMembersMemberIdErrors, DeleteFleetsFleetIdSquadsSquadIdData, DeleteFleetsFleetIdSquadsSquadIdResponses, DeleteFleetsFleetIdSquadsSquadIdErrors, PutFleetsFleetIdSquadsSquadIdData, PutFleetsFleetIdSquadsSquadIdResponses, PutFleetsFleetIdSquadsSquadIdErrors, GetFleetsFleetIdWingsData, GetFleetsFleetIdWingsResponses, GetFleetsFleetIdWingsErrors, PostFleetsFleetIdWingsData, PostFleetsFleetIdWingsResponses, PostFleetsFleetIdWingsErrors, DeleteFleetsFleetIdWingsWingIdData, DeleteFleetsFleetIdWingsWingIdResponses, DeleteFleetsFleetIdWingsWingIdErrors, PutFleetsFleetIdWingsWingIdData, PutFleetsFleetIdWingsWingIdResponses, PutFleetsFleetIdWingsWingIdErrors, PostFleetsFleetIdWingsWingIdSquadsData, PostFleetsFleetIdWingsWingIdSquadsResponses, PostFleetsFleetIdWingsWingIdSquadsErrors, GetFwLeaderboardsData, GetFwLeaderboardsResponses, GetFwLeaderboardsErrors, GetFwLeaderboardsCharactersData, GetFwLeaderboardsCharactersResponses, GetFwLeaderboardsCharactersErrors, GetFwLeaderboardsCorporationsData, GetFwLeaderboardsCorporationsResponses, GetFwLeaderboardsCorporationsErrors, GetFwStatsData, GetFwStatsResponses, GetFwStatsErrors, GetFwSystemsData, GetFwSystemsResponses, GetFwSystemsErrors, GetFwWarsData, GetFwWarsResponses, GetFwWarsErrors, GetIncursionsData, GetIncursionsResponses, GetIncursionsErrors, GetIndustryFacilitiesData, GetIndustryFacilitiesResponses, GetIndustryFacilitiesErrors, GetIndustrySystemsData, GetIndustrySystemsResponses, GetIndustrySystemsErrors, GetInsurancePricesData, GetInsurancePricesResponses, GetInsurancePricesErrors, GetKillmailsKillmailIdKillmailHashData, GetKillmailsKillmailIdKillmailHashResponses, GetKillmailsKillmailIdKillmailHashErrors, GetLoyaltyStoresCorporationIdOffersData, GetLoyaltyStoresCorporationIdOffersResponses, GetLoyaltyStoresCorporationIdOffersErrors, GetMarketsGroupsData, GetMarketsGroupsResponses, GetMarketsGroupsErrors, GetMarketsGroupsMarketGroupIdData, GetMarketsGroupsMarketGroupIdResponses, GetMarketsGroupsMarketGroupIdErrors, GetMarketsPricesData, GetMarketsPricesResponses, GetMarketsPricesErrors, GetMarketsStructuresStructureIdData, GetMarketsStructuresStructureIdResponses, GetMarketsStructuresStructureIdErrors, GetMarketsRegionIdHistoryData, GetMarketsRegionIdHistoryResponses, GetMarketsRegionIdHistoryErrors, GetMarketsRegionIdOrdersData, GetMarketsRegionIdOrdersResponses, GetMarketsRegionIdOrdersErrors, GetMarketsRegionIdTypesData, GetMarketsRegionIdTypesResponses, GetMarketsRegionIdTypesErrors, GetRouteOriginDestinationData, GetRouteOriginDestinationResponses, GetRouteOriginDestinationErrors, GetSovereigntyCampaignsData, GetSovereigntyCampaignsResponses, GetSovereigntyCampaignsErrors, GetSovereigntyMapData, GetSovereigntyMapResponses, GetSovereigntyMapErrors, GetSovereigntyStructuresData, GetSovereigntyStructuresResponses, GetSovereigntyStructuresErrors, GetStatusData, GetStatusResponses, GetStatusErrors, PostUiAutopilotWaypointData, PostUiAutopilotWaypointResponses, PostUiAutopilotWaypointErrors, PostUiOpenwindowContractData, PostUiOpenwindowContractResponses, PostUiOpenwindowContractErrors, PostUiOpenwindowInformationData, PostUiOpenwindowInformationResponses, PostUiOpenwindowInformationErrors, PostUiOpenwindowMarketdetailsData, PostUiOpenwindowMarketdetailsResponses, PostUiOpenwindowMarketdetailsErrors, PostUiOpenwindowNewmailData, PostUiOpenwindowNewmailResponses, PostUiOpenwindowNewmailErrors, GetUniverseAncestriesData, GetUniverseAncestriesResponses, GetUniverseAncestriesErrors, GetUniverseAsteroidBeltsAsteroidBeltIdData, GetUniverseAsteroidBeltsAsteroidBeltIdResponses, GetUniverseAsteroidBeltsAsteroidBeltIdErrors, GetUniverseBloodlinesData, GetUniverseBloodlinesResponses, GetUniverseBloodlinesErrors, GetUniverseCategoriesData, GetUniverseCategoriesResponses, GetUniverseCategoriesErrors, GetUniverseCategoriesCategoryIdData, GetUniverseCategoriesCategoryIdResponses, GetUniverseCategoriesCategoryIdErrors, GetUniverseConstellationsData, GetUniverseConstellationsResponses, GetUniverseConstellationsErrors, GetUniverseConstellationsConstellationIdData, GetUniverseConstellationsConstellationIdResponses, GetUniverseConstellationsConstellationIdErrors, GetUniverseFactionsData, GetUniverseFactionsResponses, GetUniverseFactionsErrors, GetUniverseGraphicsData, GetUniverseGraphicsResponses, GetUniverseGraphicsErrors, GetUniverseGraphicsGraphicIdData, GetUniverseGraphicsGraphicIdResponses, GetUniverseGraphicsGraphicIdErrors, GetUniverseGroupsData, GetUniverseGroupsResponses, GetUniverseGroupsErrors, GetUniverseGroupsGroupIdData, GetUniverseGroupsGroupIdResponses, GetUniverseGroupsGroupIdErrors, PostUniverseIdsData, PostUniverseIdsResponses, PostUniverseIdsErrors, GetUniverseMoonsMoonIdData, GetUniverseMoonsMoonIdResponses, GetUniverseMoonsMoonIdErrors, PostUniverseNamesData, PostUniverseNamesResponses, PostUniverseNamesErrors, GetUniversePlanetsPlanetIdData, GetUniversePlanetsPlanetIdResponses, GetUniversePlanetsPlanetIdErrors, GetUniverseRacesData, GetUniverseRacesResponses, GetUniverseRacesErrors, GetUniverseRegionsData, GetUniverseRegionsResponses, GetUniverseRegionsErrors, GetUniverseRegionsRegionIdData, GetUniverseRegionsRegionIdResponses, GetUniverseRegionsRegionIdErrors, GetUniverseSchematicsSchematicIdData, GetUniverseSchematicsSchematicIdResponses, GetUniverseSchematicsSchematicIdErrors, GetUniverseStargatesStargateIdData, GetUniverseStargatesStargateIdResponses, GetUniverseStargatesStargateIdErrors, GetUniverseStarsStarIdData, GetUniverseStarsStarIdResponses, GetUniverseStarsStarIdErrors, GetUniverseStationsStationIdData, GetUniverseStationsStationIdResponses, GetUniverseStationsStationIdErrors, GetUniverseStructuresData, GetUniverseStructuresResponses, GetUniverseStructuresErrors, GetUniverseStructuresStructureIdData, GetUniverseStructuresStructureIdResponses, GetUniverseStructuresStructureIdErrors, GetUniverseSystemJumpsData, GetUniverseSystemJumpsResponses, GetUniverseSystemJumpsErrors, GetUniverseSystemKillsData, GetUniverseSystemKillsResponses, GetUniverseSystemKillsErrors, GetUniverseSystemsData, GetUniverseSystemsResponses, GetUniverseSystemsErrors, GetUniverseSystemsSystemIdData, GetUniverseSystemsSystemIdResponses, GetUniverseSystemsSystemIdErrors, GetUniverseTypesData, GetUniverseTypesResponses, GetUniverseTypesErrors, GetUniverseTypesTypeIdData, GetUniverseTypesTypeIdResponses, GetUniverseTypesTypeIdErrors, GetWarsData, GetWarsResponses, GetWarsErrors, GetWarsWarIdData, GetWarsWarIdResponses, GetWarsWarIdErrors, GetWarsWarIdKillmailsData, GetWarsWarIdKillmailsResponses, GetWarsWarIdKillmailsErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List all alliances
 * List all active player alliances
 */
export const getAlliances = <ThrowOnError extends boolean = false>(options: Options<GetAlliancesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAlliancesResponses, GetAlliancesErrors, ThrowOnError>({
        url: '/alliances',
        ...options
    });
};

/**
 * Get alliance information
 * Public information about an alliance
 */
export const getAlliancesAllianceId = <ThrowOnError extends boolean = false>(options: Options<GetAlliancesAllianceIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAlliancesAllianceIdResponses, GetAlliancesAllianceIdErrors, ThrowOnError>({
        url: '/alliances/{alliance_id}',
        ...options
    });
};

/**
 * Get alliance contacts
 * Return contacts of an alliance
 */
export const getAlliancesAllianceIdContacts = <ThrowOnError extends boolean = false>(options: Options<GetAlliancesAllianceIdContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAlliancesAllianceIdContactsResponses, GetAlliancesAllianceIdContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/alliances/{alliance_id}/contacts',
        ...options
    });
};

/**
 * Get alliance contact labels
 * Return custom labels for an alliance's contacts
 */
export const getAlliancesAllianceIdContactsLabels = <ThrowOnError extends boolean = false>(options: Options<GetAlliancesAllianceIdContactsLabelsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAlliancesAllianceIdContactsLabelsResponses, GetAlliancesAllianceIdContactsLabelsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/alliances/{alliance_id}/contacts/labels',
        ...options
    });
};

/**
 * List alliance's corporations
 * List all current member corporations of an alliance
 */
export const getAlliancesAllianceIdCorporations = <ThrowOnError extends boolean = false>(options: Options<GetAlliancesAllianceIdCorporationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAlliancesAllianceIdCorporationsResponses, GetAlliancesAllianceIdCorporationsErrors, ThrowOnError>({
        url: '/alliances/{alliance_id}/corporations',
        ...options
    });
};

/**
 * Get alliance icon
 * Get the icon urls for a alliance
 *
 * This route expires daily at 11:05
 */
export const getAlliancesAllianceIdIcons = <ThrowOnError extends boolean = false>(options: Options<GetAlliancesAllianceIdIconsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAlliancesAllianceIdIconsResponses, GetAlliancesAllianceIdIconsErrors, ThrowOnError>({
        url: '/alliances/{alliance_id}/icons',
        ...options
    });
};

/**
 * Character affiliation
 * Bulk lookup of character IDs to corporation, alliance and faction
 */
export const postCharactersAffiliation = <ThrowOnError extends boolean = false>(options: Options<PostCharactersAffiliationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersAffiliationResponses, PostCharactersAffiliationErrors, ThrowOnError>({
        url: '/characters/affiliation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get character's public information
 * Public information about a character
 */
export const getCharactersCharacterId = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdResponses, GetCharactersCharacterIdErrors, ThrowOnError>({
        url: '/characters/{character_id}',
        ...options
    });
};

/**
 * Get agents research
 * Return a list of agents research information for a character. The formula for finding the current research points with an agent is: currentPoints = remainderPoints + pointsPerDay * days(currentTime - researchStartDate)
 */
export const getCharactersCharacterIdAgentsResearch = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdAgentsResearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdAgentsResearchResponses, GetCharactersCharacterIdAgentsResearchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/agents_research',
        ...options
    });
};

/**
 * Get character assets
 * Return a list of the characters assets
 */
export const getCharactersCharacterIdAssets = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdAssetsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdAssetsResponses, GetCharactersCharacterIdAssetsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/assets',
        ...options
    });
};

/**
 * Get character asset locations
 * Return locations for a set of item ids, which you can get from character assets endpoint. Coordinates for items in hangars or stations are set to (0,0,0)
 */
export const postCharactersCharacterIdAssetsLocations = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdAssetsLocationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdAssetsLocationsResponses, PostCharactersCharacterIdAssetsLocationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/assets/locations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get character asset names
 * Return names for a set of item ids, which you can get from character assets endpoint. Typically used for items that can customize names, like containers or ships.
 */
export const postCharactersCharacterIdAssetsNames = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdAssetsNamesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdAssetsNamesResponses, PostCharactersCharacterIdAssetsNamesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/assets/names',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get character attributes
 * Return attributes of a character
 */
export const getCharactersCharacterIdAttributes = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdAttributesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdAttributesResponses, GetCharactersCharacterIdAttributesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/attributes',
        ...options
    });
};

/**
 * Get blueprints
 * Return a list of blueprints the character owns
 */
export const getCharactersCharacterIdBlueprints = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdBlueprintsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdBlueprintsResponses, GetCharactersCharacterIdBlueprintsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/blueprints',
        ...options
    });
};

/**
 * List calendar event summaries
 * Get 50 event summaries from the calendar. If no from_event ID is given, the resource will return the next 50 chronological event summaries from now. If a from_event ID is specified, it will return the next 50 chronological event summaries from after that event
 */
export const getCharactersCharacterIdCalendar = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdCalendarData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdCalendarResponses, GetCharactersCharacterIdCalendarErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/calendar',
        ...options
    });
};

/**
 * Get an event
 * Get all the information for a specific event
 */
export const getCharactersCharacterIdCalendarEventId = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdCalendarEventIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdCalendarEventIdResponses, GetCharactersCharacterIdCalendarEventIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/calendar/{event_id}',
        ...options
    });
};

/**
 * Respond to an event
 * Set your response status to an event
 */
export const putCharactersCharacterIdCalendarEventId = <ThrowOnError extends boolean = false>(options: Options<PutCharactersCharacterIdCalendarEventIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutCharactersCharacterIdCalendarEventIdResponses, PutCharactersCharacterIdCalendarEventIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/calendar/{event_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get attendees
 * Get all invited attendees for a given event
 */
export const getCharactersCharacterIdCalendarEventIdAttendees = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdCalendarEventIdAttendeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdCalendarEventIdAttendeesResponses, GetCharactersCharacterIdCalendarEventIdAttendeesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/calendar/{event_id}/attendees',
        ...options
    });
};

/**
 * Get clones
 * A list of the character's clones
 */
export const getCharactersCharacterIdClones = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdClonesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdClonesResponses, GetCharactersCharacterIdClonesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/clones',
        ...options
    });
};

/**
 * Delete contacts
 * Bulk delete contacts
 */
export const deleteCharactersCharacterIdContacts = <ThrowOnError extends boolean = false>(options: Options<DeleteCharactersCharacterIdContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCharactersCharacterIdContactsResponses, DeleteCharactersCharacterIdContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contacts',
        ...options
    });
};

/**
 * Get contacts
 * Return contacts of a character
 */
export const getCharactersCharacterIdContacts = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdContactsResponses, GetCharactersCharacterIdContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contacts',
        ...options
    });
};

/**
 * Add contacts
 * Bulk add contacts with same settings
 */
export const postCharactersCharacterIdContacts = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdContactsResponses, PostCharactersCharacterIdContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Edit contacts
 * Bulk edit contacts with same settings
 */
export const putCharactersCharacterIdContacts = <ThrowOnError extends boolean = false>(options: Options<PutCharactersCharacterIdContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutCharactersCharacterIdContactsResponses, PutCharactersCharacterIdContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get contact labels
 * Return custom labels for a character's contacts
 */
export const getCharactersCharacterIdContactsLabels = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdContactsLabelsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdContactsLabelsResponses, GetCharactersCharacterIdContactsLabelsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contacts/labels',
        ...options
    });
};

/**
 * Get contracts
 * Returns contracts available to a character, only if the character is issuer, acceptor or assignee. Only returns contracts no older than 30 days, or if the status is "in_progress".
 */
export const getCharactersCharacterIdContracts = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdContractsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdContractsResponses, GetCharactersCharacterIdContractsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contracts',
        ...options
    });
};

/**
 * Get contract bids
 * Lists bids on a particular auction contract
 */
export const getCharactersCharacterIdContractsContractIdBids = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdContractsContractIdBidsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdContractsContractIdBidsResponses, GetCharactersCharacterIdContractsContractIdBidsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contracts/{contract_id}/bids',
        ...options
    });
};

/**
 * Get contract items
 * Lists items of a particular contract
 */
export const getCharactersCharacterIdContractsContractIdItems = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdContractsContractIdItemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdContractsContractIdItemsResponses, GetCharactersCharacterIdContractsContractIdItemsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/contracts/{contract_id}/items',
        ...options
    });
};

/**
 * Get corporation history
 * Get a list of all the corporations a character has been a member of
 */
export const getCharactersCharacterIdCorporationhistory = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdCorporationhistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdCorporationhistoryResponses, GetCharactersCharacterIdCorporationhistoryErrors, ThrowOnError>({
        url: '/characters/{character_id}/corporationhistory',
        ...options
    });
};

/**
 * Calculate a CSPA charge cost
 * Takes a source character ID in the url and a set of target character ID's in the body, returns a CSPA charge cost
 */
export const postCharactersCharacterIdCspa = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdCspaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdCspaResponses, PostCharactersCharacterIdCspaErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/cspa',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get jump fatigue
 * Return a character's jump activation and fatigue information
 */
export const getCharactersCharacterIdFatigue = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdFatigueData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdFatigueResponses, GetCharactersCharacterIdFatigueErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/fatigue',
        ...options
    });
};

/**
 * Get fittings
 * Return fittings of a character
 */
export const getCharactersCharacterIdFittings = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdFittingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdFittingsResponses, GetCharactersCharacterIdFittingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/fittings',
        ...options
    });
};

/**
 * Create fitting
 * Save a new fitting for a character
 */
export const postCharactersCharacterIdFittings = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdFittingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdFittingsResponses, PostCharactersCharacterIdFittingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/fittings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete fitting
 * Delete a fitting from a character
 */
export const deleteCharactersCharacterIdFittingsFittingId = <ThrowOnError extends boolean = false>(options: Options<DeleteCharactersCharacterIdFittingsFittingIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCharactersCharacterIdFittingsFittingIdResponses, DeleteCharactersCharacterIdFittingsFittingIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/fittings/{fitting_id}',
        ...options
    });
};

/**
 * Get character fleet info
 * Return the fleet ID the character is in, if any.
 */
export const getCharactersCharacterIdFleet = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdFleetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdFleetResponses, GetCharactersCharacterIdFleetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/fleet',
        ...options
    });
};

/**
 * Overview of a character involved in faction warfare
 * Statistical overview of a character involved in faction warfare
 *
 * This route expires daily at 11:05
 */
export const getCharactersCharacterIdFwStats = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdFwStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdFwStatsResponses, GetCharactersCharacterIdFwStatsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/fw/stats',
        ...options
    });
};

/**
 * Get active implants
 * Return implants on the active clone of a character
 */
export const getCharactersCharacterIdImplants = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdImplantsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdImplantsResponses, GetCharactersCharacterIdImplantsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/implants',
        ...options
    });
};

/**
 * List character industry jobs
 * List industry jobs placed by a character
 */
export const getCharactersCharacterIdIndustryJobs = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdIndustryJobsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdIndustryJobsResponses, GetCharactersCharacterIdIndustryJobsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/industry/jobs',
        ...options
    });
};

/**
 * Get a character's recent kills and losses
 * Return a list of a character's kills and losses going back 90 days
 */
export const getCharactersCharacterIdKillmailsRecent = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdKillmailsRecentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdKillmailsRecentResponses, GetCharactersCharacterIdKillmailsRecentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/killmails/recent',
        ...options
    });
};

/**
 * Get character location
 * Information about the characters current location. Returns the current solar system id, and also the current station or structure ID if applicable
 */
export const getCharactersCharacterIdLocation = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdLocationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdLocationResponses, GetCharactersCharacterIdLocationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/location',
        ...options
    });
};

/**
 * Get loyalty points
 * Return a list of loyalty points for all corporations the character has worked for
 */
export const getCharactersCharacterIdLoyaltyPoints = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdLoyaltyPointsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdLoyaltyPointsResponses, GetCharactersCharacterIdLoyaltyPointsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/loyalty/points',
        ...options
    });
};

/**
 * Return mail headers
 * Return the 50 most recent mail headers belonging to the character that match the query criteria. Queries can be filtered by label, and last_mail_id can be used to paginate backwards
 */
export const getCharactersCharacterIdMail = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdMailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdMailResponses, GetCharactersCharacterIdMailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail',
        ...options
    });
};

/**
 * Send a new mail
 * Create and send a new mail
 */
export const postCharactersCharacterIdMail = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdMailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdMailResponses, PostCharactersCharacterIdMailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get mail labels and unread counts
 * Return a list of the users mail labels, unread counts for each label and a total unread count.
 */
export const getCharactersCharacterIdMailLabels = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdMailLabelsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdMailLabelsResponses, GetCharactersCharacterIdMailLabelsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/labels',
        ...options
    });
};

/**
 * Create a mail label
 * Create a mail label
 */
export const postCharactersCharacterIdMailLabels = <ThrowOnError extends boolean = false>(options: Options<PostCharactersCharacterIdMailLabelsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCharactersCharacterIdMailLabelsResponses, PostCharactersCharacterIdMailLabelsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/labels',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a mail label
 * Delete a mail label
 */
export const deleteCharactersCharacterIdMailLabelsLabelId = <ThrowOnError extends boolean = false>(options: Options<DeleteCharactersCharacterIdMailLabelsLabelIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCharactersCharacterIdMailLabelsLabelIdResponses, DeleteCharactersCharacterIdMailLabelsLabelIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/labels/{label_id}',
        ...options
    });
};

/**
 * Return mailing list subscriptions
 * Return all mailing lists that the character is subscribed to
 */
export const getCharactersCharacterIdMailLists = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdMailListsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdMailListsResponses, GetCharactersCharacterIdMailListsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/lists',
        ...options
    });
};

/**
 * Delete a mail
 * Delete a mail
 */
export const deleteCharactersCharacterIdMailMailId = <ThrowOnError extends boolean = false>(options: Options<DeleteCharactersCharacterIdMailMailIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCharactersCharacterIdMailMailIdResponses, DeleteCharactersCharacterIdMailMailIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/{mail_id}',
        ...options
    });
};

/**
 * Return a mail
 * Return the contents of an EVE mail
 */
export const getCharactersCharacterIdMailMailId = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdMailMailIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdMailMailIdResponses, GetCharactersCharacterIdMailMailIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/{mail_id}',
        ...options
    });
};

/**
 * Update metadata about a mail
 * Update metadata about a mail
 */
export const putCharactersCharacterIdMailMailId = <ThrowOnError extends boolean = false>(options: Options<PutCharactersCharacterIdMailMailIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutCharactersCharacterIdMailMailIdResponses, PutCharactersCharacterIdMailMailIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mail/{mail_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get medals
 * Return a list of medals the character has
 */
export const getCharactersCharacterIdMedals = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdMedalsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdMedalsResponses, GetCharactersCharacterIdMedalsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/medals',
        ...options
    });
};

/**
 * Character mining ledger
 * Paginated record of all mining done by a character for the past 30 days
 */
export const getCharactersCharacterIdMining = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdMiningData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdMiningResponses, GetCharactersCharacterIdMiningErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/mining',
        ...options
    });
};

/**
 * Get character notifications
 * Return character notifications
 */
export const getCharactersCharacterIdNotifications = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdNotificationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdNotificationsResponses, GetCharactersCharacterIdNotificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/notifications',
        ...options
    });
};

/**
 * Get new contact notifications
 * Return notifications about having been added to someone's contact list
 */
export const getCharactersCharacterIdNotificationsContacts = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdNotificationsContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdNotificationsContactsResponses, GetCharactersCharacterIdNotificationsContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/notifications/contacts',
        ...options
    });
};

/**
 * Get character online
 * Checks if the character is currently online
 */
export const getCharactersCharacterIdOnline = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdOnlineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdOnlineResponses, GetCharactersCharacterIdOnlineErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/online',
        ...options
    });
};

/**
 * List open orders from a character
 * List open market orders placed by a character
 */
export const getCharactersCharacterIdOrders = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdOrdersResponses, GetCharactersCharacterIdOrdersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/orders',
        ...options
    });
};

/**
 * List historical orders by a character
 * List cancelled and expired market orders placed by a character up to 90 days in the past.
 */
export const getCharactersCharacterIdOrdersHistory = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdOrdersHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdOrdersHistoryResponses, GetCharactersCharacterIdOrdersHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/orders/history',
        ...options
    });
};

/**
 * Get colonies
 * Returns a list of all planetary colonies owned by a character.
 */
export const getCharactersCharacterIdPlanets = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdPlanetsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdPlanetsResponses, GetCharactersCharacterIdPlanetsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/planets',
        ...options
    });
};

/**
 * Get colony layout
 * Returns full details on the layout of a single planetary colony, including links, pins and routes. Note: Planetary information is only recalculated when the colony is viewed through the client. Information will not update until this criteria is met.
 */
export const getCharactersCharacterIdPlanetsPlanetId = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdPlanetsPlanetIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdPlanetsPlanetIdResponses, GetCharactersCharacterIdPlanetsPlanetIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/planets/{planet_id}',
        ...options
    });
};

/**
 * Get character portraits
 * Get portrait urls for a character
 *
 * This route expires daily at 11:05
 */
export const getCharactersCharacterIdPortrait = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdPortraitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdPortraitResponses, GetCharactersCharacterIdPortraitErrors, ThrowOnError>({
        url: '/characters/{character_id}/portrait',
        ...options
    });
};

/**
 * Get character corporation roles
 * Returns a character's corporation roles
 */
export const getCharactersCharacterIdRoles = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdRolesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdRolesResponses, GetCharactersCharacterIdRolesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/roles',
        ...options
    });
};

/**
 * Search on a string
 * Search for entities that match a given sub-string.
 */
export const getCharactersCharacterIdSearch = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdSearchResponses, GetCharactersCharacterIdSearchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/search',
        ...options
    });
};

/**
 * Get current ship
 * Get the current ship type, name and id
 */
export const getCharactersCharacterIdShip = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdShipData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdShipResponses, GetCharactersCharacterIdShipErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/ship',
        ...options
    });
};

/**
 * Get character's skill queue
 * List the configured skill queue for the given character
 */
export const getCharactersCharacterIdSkillqueue = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdSkillqueueData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdSkillqueueResponses, GetCharactersCharacterIdSkillqueueErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/skillqueue',
        ...options
    });
};

/**
 * Get character skills
 * List all trained skills for the given character
 */
export const getCharactersCharacterIdSkills = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdSkillsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdSkillsResponses, GetCharactersCharacterIdSkillsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/skills',
        ...options
    });
};

/**
 * Get standings
 * Return character standings from agents, NPC corporations, and factions
 */
export const getCharactersCharacterIdStandings = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdStandingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdStandingsResponses, GetCharactersCharacterIdStandingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/standings',
        ...options
    });
};

/**
 * Get character corporation titles
 * Returns a character's titles
 */
export const getCharactersCharacterIdTitles = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdTitlesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdTitlesResponses, GetCharactersCharacterIdTitlesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/titles',
        ...options
    });
};

/**
 * Get a character's wallet balance
 * Returns a character's wallet balance
 */
export const getCharactersCharacterIdWallet = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdWalletData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdWalletResponses, GetCharactersCharacterIdWalletErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/wallet',
        ...options
    });
};

/**
 * Get character wallet journal
 * Retrieve the given character's wallet journal going 30 days back
 */
export const getCharactersCharacterIdWalletJournal = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdWalletJournalData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdWalletJournalResponses, GetCharactersCharacterIdWalletJournalErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/wallet/journal',
        ...options
    });
};

/**
 * Get wallet transactions
 * Get wallet transactions of a character
 */
export const getCharactersCharacterIdWalletTransactions = <ThrowOnError extends boolean = false>(options: Options<GetCharactersCharacterIdWalletTransactionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCharactersCharacterIdWalletTransactionsResponses, GetCharactersCharacterIdWalletTransactionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/characters/{character_id}/wallet/transactions',
        ...options
    });
};

/**
 * Get public contract bids
 * Lists bids on a public auction contract
 */
export const getContractsPublicBidsContractId = <ThrowOnError extends boolean = false>(options: Options<GetContractsPublicBidsContractIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContractsPublicBidsContractIdResponses, unknown, ThrowOnError>({
        url: '/contracts/public/bids/{contract_id}',
        ...options
    });
};

/**
 * Get public contract items
 * Lists items of a public contract
 */
export const getContractsPublicItemsContractId = <ThrowOnError extends boolean = false>(options: Options<GetContractsPublicItemsContractIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContractsPublicItemsContractIdResponses, unknown, ThrowOnError>({
        url: '/contracts/public/items/{contract_id}',
        ...options
    });
};

/**
 * Get public contracts
 * Returns a paginated list of all public contracts in the given region
 */
export const getContractsPublicRegionId = <ThrowOnError extends boolean = false>(options: Options<GetContractsPublicRegionIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContractsPublicRegionIdResponses, GetContractsPublicRegionIdErrors, ThrowOnError>({
        url: '/contracts/public/{region_id}',
        ...options
    });
};

/**
 * Moon extraction timers
 * Extraction timers for all moon chunks being extracted by refineries belonging to a corporation.
 */
export const getCorporationCorporationIdMiningExtractions = <ThrowOnError extends boolean = false>(options: Options<GetCorporationCorporationIdMiningExtractionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationCorporationIdMiningExtractionsResponses, GetCorporationCorporationIdMiningExtractionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporation/{corporation_id}/mining/extractions',
        ...options
    });
};

/**
 * Corporation mining observers
 * Paginated list of all entities capable of observing and recording mining for a corporation
 */
export const getCorporationCorporationIdMiningObservers = <ThrowOnError extends boolean = false>(options: Options<GetCorporationCorporationIdMiningObserversData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationCorporationIdMiningObserversResponses, GetCorporationCorporationIdMiningObserversErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporation/{corporation_id}/mining/observers',
        ...options
    });
};

/**
 * Observed corporation mining
 * Paginated record of all mining seen by an observer
 */
export const getCorporationCorporationIdMiningObserversObserverId = <ThrowOnError extends boolean = false>(options: Options<GetCorporationCorporationIdMiningObserversObserverIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationCorporationIdMiningObserversObserverIdResponses, GetCorporationCorporationIdMiningObserversObserverIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporation/{corporation_id}/mining/observers/{observer_id}',
        ...options
    });
};

/**
 * Get npc corporations
 * Get a list of npc corporations
 *
 * This route expires daily at 11:05
 */
export const getCorporationsNpccorps = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsNpccorpsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsNpccorpsResponses, GetCorporationsNpccorpsErrors, ThrowOnError>({
        url: '/corporations/npccorps',
        ...options
    });
};

/**
 * Get corporation information
 * Public information about a corporation
 */
export const getCorporationsCorporationId = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdResponses, GetCorporationsCorporationIdErrors, ThrowOnError>({
        url: '/corporations/{corporation_id}',
        ...options
    });
};

/**
 * Get alliance history
 * Get a list of all the alliances a corporation has been a member of
 */
export const getCorporationsCorporationIdAlliancehistory = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdAlliancehistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdAlliancehistoryResponses, GetCorporationsCorporationIdAlliancehistoryErrors, ThrowOnError>({
        url: '/corporations/{corporation_id}/alliancehistory',
        ...options
    });
};

/**
 * Get corporation assets
 * Return a list of the corporation assets
 */
export const getCorporationsCorporationIdAssets = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdAssetsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdAssetsResponses, GetCorporationsCorporationIdAssetsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/assets',
        ...options
    });
};

/**
 * Get corporation asset locations
 * Return locations for a set of item ids, which you can get from corporation assets endpoint. Coordinates for items in hangars or stations are set to (0,0,0)
 */
export const postCorporationsCorporationIdAssetsLocations = <ThrowOnError extends boolean = false>(options: Options<PostCorporationsCorporationIdAssetsLocationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCorporationsCorporationIdAssetsLocationsResponses, PostCorporationsCorporationIdAssetsLocationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/assets/locations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get corporation asset names
 * Return names for a set of item ids, which you can get from corporation assets endpoint. Only valid for items that can customize names, like containers or ships
 */
export const postCorporationsCorporationIdAssetsNames = <ThrowOnError extends boolean = false>(options: Options<PostCorporationsCorporationIdAssetsNamesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCorporationsCorporationIdAssetsNamesResponses, PostCorporationsCorporationIdAssetsNamesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/assets/names',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get corporation blueprints
 * Returns a list of blueprints the corporation owns
 */
export const getCorporationsCorporationIdBlueprints = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdBlueprintsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdBlueprintsResponses, GetCorporationsCorporationIdBlueprintsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/blueprints',
        ...options
    });
};

/**
 * Get corporation contacts
 * Return contacts of a corporation
 */
export const getCorporationsCorporationIdContacts = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdContactsResponses, GetCorporationsCorporationIdContactsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/contacts',
        ...options
    });
};

/**
 * Get corporation contact labels
 * Return custom labels for a corporation's contacts
 */
export const getCorporationsCorporationIdContactsLabels = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdContactsLabelsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdContactsLabelsResponses, GetCorporationsCorporationIdContactsLabelsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/contacts/labels',
        ...options
    });
};

/**
 * Get all corporation ALSC logs
 * Returns logs recorded in the past seven days from all audit log secure containers (ALSC) owned by a given corporation
 */
export const getCorporationsCorporationIdContainersLogs = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdContainersLogsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdContainersLogsResponses, GetCorporationsCorporationIdContainersLogsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/containers/logs',
        ...options
    });
};

/**
 * Get corporation contracts
 * Returns contracts available to a corporation, only if the corporation is issuer, acceptor or assignee. Only returns contracts no older than 30 days, or if the status is "in_progress".
 */
export const getCorporationsCorporationIdContracts = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdContractsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdContractsResponses, GetCorporationsCorporationIdContractsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/contracts',
        ...options
    });
};

/**
 * Get corporation contract bids
 * Lists bids on a particular auction contract
 */
export const getCorporationsCorporationIdContractsContractIdBids = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdContractsContractIdBidsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdContractsContractIdBidsResponses, GetCorporationsCorporationIdContractsContractIdBidsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/contracts/{contract_id}/bids',
        ...options
    });
};

/**
 * Get corporation contract items
 * Lists items of a particular contract
 */
export const getCorporationsCorporationIdContractsContractIdItems = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdContractsContractIdItemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdContractsContractIdItemsResponses, GetCorporationsCorporationIdContractsContractIdItemsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/contracts/{contract_id}/items',
        ...options
    });
};

/**
 * List corporation customs offices
 * List customs offices owned by a corporation
 */
export const getCorporationsCorporationIdCustomsOffices = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdCustomsOfficesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdCustomsOfficesResponses, GetCorporationsCorporationIdCustomsOfficesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/customs_offices',
        ...options
    });
};

/**
 * Get corporation divisions
 * Return corporation hangar and wallet division names, only show if a division is not using the default name
 */
export const getCorporationsCorporationIdDivisions = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdDivisionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdDivisionsResponses, GetCorporationsCorporationIdDivisionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/divisions',
        ...options
    });
};

/**
 * Get corporation facilities
 * Return a corporation's facilities
 */
export const getCorporationsCorporationIdFacilities = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdFacilitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdFacilitiesResponses, GetCorporationsCorporationIdFacilitiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/facilities',
        ...options
    });
};

/**
 * Overview of a corporation involved in faction warfare
 * Statistics about a corporation involved in faction warfare
 *
 * This route expires daily at 11:05
 */
export const getCorporationsCorporationIdFwStats = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdFwStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdFwStatsResponses, GetCorporationsCorporationIdFwStatsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/fw/stats',
        ...options
    });
};

/**
 * Get corporation icon
 * Get the icon urls for a corporation
 */
export const getCorporationsCorporationIdIcons = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdIconsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdIconsResponses, GetCorporationsCorporationIdIconsErrors, ThrowOnError>({
        url: '/corporations/{corporation_id}/icons',
        ...options
    });
};

/**
 * List corporation industry jobs
 * List industry jobs run by a corporation
 */
export const getCorporationsCorporationIdIndustryJobs = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdIndustryJobsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdIndustryJobsResponses, GetCorporationsCorporationIdIndustryJobsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/industry/jobs',
        ...options
    });
};

/**
 * Get a corporation's recent kills and losses
 * Get a list of a corporation's kills and losses going back 90 days
 */
export const getCorporationsCorporationIdKillmailsRecent = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdKillmailsRecentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdKillmailsRecentResponses, GetCorporationsCorporationIdKillmailsRecentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/killmails/recent',
        ...options
    });
};

/**
 * Get corporation medals
 * Returns a corporation's medals
 */
export const getCorporationsCorporationIdMedals = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdMedalsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdMedalsResponses, GetCorporationsCorporationIdMedalsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/medals',
        ...options
    });
};

/**
 * Get corporation issued medals
 * Returns medals issued by a corporation
 */
export const getCorporationsCorporationIdMedalsIssued = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdMedalsIssuedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdMedalsIssuedResponses, GetCorporationsCorporationIdMedalsIssuedErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/medals/issued',
        ...options
    });
};

/**
 * Get corporation members
 * Return the current member list of a corporation, the token's character need to be a member of the corporation.
 */
export const getCorporationsCorporationIdMembers = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdMembersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdMembersResponses, GetCorporationsCorporationIdMembersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/members',
        ...options
    });
};

/**
 * Get corporation member limit
 * Return a corporation's member limit, not including CEO himself
 */
export const getCorporationsCorporationIdMembersLimit = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdMembersLimitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdMembersLimitResponses, GetCorporationsCorporationIdMembersLimitErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/members/limit',
        ...options
    });
};

/**
 * Get corporation's members' titles
 * Returns a corporation's members' titles
 */
export const getCorporationsCorporationIdMembersTitles = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdMembersTitlesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdMembersTitlesResponses, GetCorporationsCorporationIdMembersTitlesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/members/titles',
        ...options
    });
};

/**
 * Track corporation members
 * Returns additional information about a corporation's members which helps tracking their activities
 */
export const getCorporationsCorporationIdMembertracking = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdMembertrackingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdMembertrackingResponses, GetCorporationsCorporationIdMembertrackingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/membertracking',
        ...options
    });
};

/**
 * List open orders from a corporation
 * List open market orders placed on behalf of a corporation
 */
export const getCorporationsCorporationIdOrders = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdOrdersResponses, GetCorporationsCorporationIdOrdersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/orders',
        ...options
    });
};

/**
 * List historical orders from a corporation
 * List cancelled and expired market orders placed on behalf of a corporation up to 90 days in the past.
 */
export const getCorporationsCorporationIdOrdersHistory = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdOrdersHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdOrdersHistoryResponses, GetCorporationsCorporationIdOrdersHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/orders/history',
        ...options
    });
};

/**
 * List corporation projects
 * Listing of all (active) corporation projects.
 */
export const getCorporationsProjectsListing = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsProjectsListingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsProjectsListingResponses, GetCorporationsProjectsListingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/projects',
        ...options
    });
};

/**
 * Get project details
 * Get the details of a corporation project.
 */
export const getCorporationsProjectsDetail = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsProjectsDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsProjectsDetailResponses, GetCorporationsProjectsDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/projects/{project_id}',
        ...options
    });
};

/**
 * Get your project contribution
 * Show your contribution to a corporation project.
 */
export const getCorporationsProjectsContribution = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsProjectsContributionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsProjectsContributionResponses, GetCorporationsProjectsContributionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/projects/{project_id}/contribution/{character_id}',
        ...options
    });
};

/**
 * List project contributors
 * Listing of all contributors to a corporation project.
 */
export const getCorporationsProjectsContributors = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsProjectsContributorsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsProjectsContributorsResponses, GetCorporationsProjectsContributorsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/projects/{project_id}/contributors',
        ...options
    });
};

/**
 * Get corporation member roles
 * Return the roles of all members if the character has the personnel manager role or any grantable role.
 */
export const getCorporationsCorporationIdRoles = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdRolesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdRolesResponses, GetCorporationsCorporationIdRolesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/roles',
        ...options
    });
};

/**
 * Get corporation member roles history
 * Return how roles have changed for a coporation's members, up to a month
 */
export const getCorporationsCorporationIdRolesHistory = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdRolesHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdRolesHistoryResponses, GetCorporationsCorporationIdRolesHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/roles/history',
        ...options
    });
};

/**
 * Get corporation shareholders
 * Return the current shareholders of a corporation.
 */
export const getCorporationsCorporationIdShareholders = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdShareholdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdShareholdersResponses, GetCorporationsCorporationIdShareholdersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/shareholders',
        ...options
    });
};

/**
 * Get corporation standings
 * Return corporation standings from agents, NPC corporations, and factions
 */
export const getCorporationsCorporationIdStandings = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdStandingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdStandingsResponses, GetCorporationsCorporationIdStandingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/standings',
        ...options
    });
};

/**
 * Get corporation starbases (POSes)
 * Returns list of corporation starbases (POSes)
 */
export const getCorporationsCorporationIdStarbases = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdStarbasesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdStarbasesResponses, GetCorporationsCorporationIdStarbasesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/starbases',
        ...options
    });
};

/**
 * Get starbase (POS) detail
 * Returns various settings and fuels of a starbase (POS)
 */
export const getCorporationsCorporationIdStarbasesStarbaseId = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdStarbasesStarbaseIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdStarbasesStarbaseIdResponses, GetCorporationsCorporationIdStarbasesStarbaseIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/starbases/{starbase_id}',
        ...options
    });
};

/**
 * Get corporation structures
 * Get a list of corporation structures. This route's version includes the changes to structures detailed in this blog: https://www.eveonline.com/article/upwell-2.0-structures-changes-coming-on-february-13th
 */
export const getCorporationsCorporationIdStructures = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdStructuresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdStructuresResponses, GetCorporationsCorporationIdStructuresErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/structures',
        ...options
    });
};

/**
 * Get corporation titles
 * Returns a corporation's titles
 */
export const getCorporationsCorporationIdTitles = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdTitlesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdTitlesResponses, GetCorporationsCorporationIdTitlesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/titles',
        ...options
    });
};

/**
 * Returns a corporation's wallet balance
 * Get a corporation's wallets
 */
export const getCorporationsCorporationIdWallets = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdWalletsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdWalletsResponses, GetCorporationsCorporationIdWalletsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/wallets',
        ...options
    });
};

/**
 * Get corporation wallet journal
 * Retrieve the given corporation's wallet journal for the given division going 30 days back
 */
export const getCorporationsCorporationIdWalletsDivisionJournal = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdWalletsDivisionJournalData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdWalletsDivisionJournalResponses, GetCorporationsCorporationIdWalletsDivisionJournalErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/wallets/{division}/journal',
        ...options
    });
};

/**
 * Get corporation wallet transactions
 * Get wallet transactions of a corporation
 */
export const getCorporationsCorporationIdWalletsDivisionTransactions = <ThrowOnError extends boolean = false>(options: Options<GetCorporationsCorporationIdWalletsDivisionTransactionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCorporationsCorporationIdWalletsDivisionTransactionsResponses, GetCorporationsCorporationIdWalletsDivisionTransactionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/corporations/{corporation_id}/wallets/{division}/transactions',
        ...options
    });
};

/**
 * Get attributes
 * Get a list of dogma attribute ids
 *
 * This route expires daily at 11:05
 */
export const getDogmaAttributes = <ThrowOnError extends boolean = false>(options: Options<GetDogmaAttributesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDogmaAttributesResponses, GetDogmaAttributesErrors, ThrowOnError>({
        url: '/dogma/attributes',
        ...options
    });
};

/**
 * Get attribute information
 * Get information on a dogma attribute
 *
 * This route expires daily at 11:05
 */
export const getDogmaAttributesAttributeId = <ThrowOnError extends boolean = false>(options: Options<GetDogmaAttributesAttributeIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDogmaAttributesAttributeIdResponses, GetDogmaAttributesAttributeIdErrors, ThrowOnError>({
        url: '/dogma/attributes/{attribute_id}',
        ...options
    });
};

/**
 * Get dynamic item information
 * Returns info about a dynamic item resulting from mutation with a mutaplasmid.
 *
 * This route expires daily at 11:05
 */
export const getDogmaDynamicItemsTypeIdItemId = <ThrowOnError extends boolean = false>(options: Options<GetDogmaDynamicItemsTypeIdItemIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDogmaDynamicItemsTypeIdItemIdResponses, GetDogmaDynamicItemsTypeIdItemIdErrors, ThrowOnError>({
        url: '/dogma/dynamic/items/{type_id}/{item_id}',
        ...options
    });
};

/**
 * Get effects
 * Get a list of dogma effect ids
 *
 * This route expires daily at 11:05
 */
export const getDogmaEffects = <ThrowOnError extends boolean = false>(options: Options<GetDogmaEffectsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDogmaEffectsResponses, GetDogmaEffectsErrors, ThrowOnError>({
        url: '/dogma/effects',
        ...options
    });
};

/**
 * Get effect information
 * Get information on a dogma effect
 *
 * This route expires daily at 11:05
 */
export const getDogmaEffectsEffectId = <ThrowOnError extends boolean = false>(options: Options<GetDogmaEffectsEffectIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDogmaEffectsEffectIdResponses, GetDogmaEffectsEffectIdErrors, ThrowOnError>({
        url: '/dogma/effects/{effect_id}',
        ...options
    });
};

/**
 * Get fleet information
 * Return details about a fleet
 */
export const getFleetsFleetId = <ThrowOnError extends boolean = false>(options: Options<GetFleetsFleetIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFleetsFleetIdResponses, GetFleetsFleetIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}',
        ...options
    });
};

/**
 * Update fleet
 * Update settings about a fleet
 */
export const putFleetsFleetId = <ThrowOnError extends boolean = false>(options: Options<PutFleetsFleetIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutFleetsFleetIdResponses, PutFleetsFleetIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get fleet members
 * Return information about fleet members
 */
export const getFleetsFleetIdMembers = <ThrowOnError extends boolean = false>(options: Options<GetFleetsFleetIdMembersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFleetsFleetIdMembersResponses, GetFleetsFleetIdMembersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/members',
        ...options
    });
};

/**
 * Create fleet invitation
 * Invite a character into the fleet. If a character has a CSPA charge set it is not possible to invite them to the fleet using ESI
 */
export const postFleetsFleetIdMembers = <ThrowOnError extends boolean = false>(options: Options<PostFleetsFleetIdMembersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostFleetsFleetIdMembersResponses, PostFleetsFleetIdMembersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Kick fleet member
 * Kick a fleet member
 */
export const deleteFleetsFleetIdMembersMemberId = <ThrowOnError extends boolean = false>(options: Options<DeleteFleetsFleetIdMembersMemberIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteFleetsFleetIdMembersMemberIdResponses, DeleteFleetsFleetIdMembersMemberIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/members/{member_id}',
        ...options
    });
};

/**
 * Move fleet member
 * Move a fleet member around
 */
export const putFleetsFleetIdMembersMemberId = <ThrowOnError extends boolean = false>(options: Options<PutFleetsFleetIdMembersMemberIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutFleetsFleetIdMembersMemberIdResponses, PutFleetsFleetIdMembersMemberIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/members/{member_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete fleet squad
 * Delete a fleet squad, only empty squads can be deleted
 */
export const deleteFleetsFleetIdSquadsSquadId = <ThrowOnError extends boolean = false>(options: Options<DeleteFleetsFleetIdSquadsSquadIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteFleetsFleetIdSquadsSquadIdResponses, DeleteFleetsFleetIdSquadsSquadIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/squads/{squad_id}',
        ...options
    });
};

/**
 * Rename fleet squad
 * Rename a fleet squad
 */
export const putFleetsFleetIdSquadsSquadId = <ThrowOnError extends boolean = false>(options: Options<PutFleetsFleetIdSquadsSquadIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutFleetsFleetIdSquadsSquadIdResponses, PutFleetsFleetIdSquadsSquadIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/squads/{squad_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get fleet wings
 * Return information about wings in a fleet
 */
export const getFleetsFleetIdWings = <ThrowOnError extends boolean = false>(options: Options<GetFleetsFleetIdWingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFleetsFleetIdWingsResponses, GetFleetsFleetIdWingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/wings',
        ...options
    });
};

/**
 * Create fleet wing
 * Create a new wing in a fleet
 */
export const postFleetsFleetIdWings = <ThrowOnError extends boolean = false>(options: Options<PostFleetsFleetIdWingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostFleetsFleetIdWingsResponses, PostFleetsFleetIdWingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/wings',
        ...options
    });
};

/**
 * Delete fleet wing
 * Delete a fleet wing, only empty wings can be deleted. The wing may contain squads, but the squads must be empty
 */
export const deleteFleetsFleetIdWingsWingId = <ThrowOnError extends boolean = false>(options: Options<DeleteFleetsFleetIdWingsWingIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteFleetsFleetIdWingsWingIdResponses, DeleteFleetsFleetIdWingsWingIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/wings/{wing_id}',
        ...options
    });
};

/**
 * Rename fleet wing
 * Rename a fleet wing
 */
export const putFleetsFleetIdWingsWingId = <ThrowOnError extends boolean = false>(options: Options<PutFleetsFleetIdWingsWingIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutFleetsFleetIdWingsWingIdResponses, PutFleetsFleetIdWingsWingIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/wings/{wing_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create fleet squad
 * Create a new squad in a fleet
 */
export const postFleetsFleetIdWingsWingIdSquads = <ThrowOnError extends boolean = false>(options: Options<PostFleetsFleetIdWingsWingIdSquadsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostFleetsFleetIdWingsWingIdSquadsResponses, PostFleetsFleetIdWingsWingIdSquadsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/fleets/{fleet_id}/wings/{wing_id}/squads',
        ...options
    });
};

/**
 * List of the top factions in faction warfare
 * Top 4 leaderboard of factions for kills and victory points separated by total, last week and yesterday
 *
 * This route expires daily at 11:05
 */
export const getFwLeaderboards = <ThrowOnError extends boolean = false>(options: Options<GetFwLeaderboardsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFwLeaderboardsResponses, GetFwLeaderboardsErrors, ThrowOnError>({
        url: '/fw/leaderboards',
        ...options
    });
};

/**
 * List of the top pilots in faction warfare
 * Top 100 leaderboard of pilots for kills and victory points separated by total, last week and yesterday
 *
 * This route expires daily at 11:05
 */
export const getFwLeaderboardsCharacters = <ThrowOnError extends boolean = false>(options: Options<GetFwLeaderboardsCharactersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFwLeaderboardsCharactersResponses, GetFwLeaderboardsCharactersErrors, ThrowOnError>({
        url: '/fw/leaderboards/characters',
        ...options
    });
};

/**
 * List of the top corporations in faction warfare
 * Top 10 leaderboard of corporations for kills and victory points separated by total, last week and yesterday
 *
 * This route expires daily at 11:05
 */
export const getFwLeaderboardsCorporations = <ThrowOnError extends boolean = false>(options: Options<GetFwLeaderboardsCorporationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFwLeaderboardsCorporationsResponses, GetFwLeaderboardsCorporationsErrors, ThrowOnError>({
        url: '/fw/leaderboards/corporations',
        ...options
    });
};

/**
 * An overview of statistics about factions involved in faction warfare
 * Statistical overviews of factions involved in faction warfare
 *
 * This route expires daily at 11:05
 */
export const getFwStats = <ThrowOnError extends boolean = false>(options: Options<GetFwStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFwStatsResponses, GetFwStatsErrors, ThrowOnError>({
        url: '/fw/stats',
        ...options
    });
};

/**
 * Ownership of faction warfare systems
 * An overview of the current ownership of faction warfare solar systems
 */
export const getFwSystems = <ThrowOnError extends boolean = false>(options: Options<GetFwSystemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFwSystemsResponses, GetFwSystemsErrors, ThrowOnError>({
        url: '/fw/systems',
        ...options
    });
};

/**
 * Data about which NPC factions are at war
 * Data about which NPC factions are at war
 *
 * This route expires daily at 11:05
 */
export const getFwWars = <ThrowOnError extends boolean = false>(options: Options<GetFwWarsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFwWarsResponses, GetFwWarsErrors, ThrowOnError>({
        url: '/fw/wars',
        ...options
    });
};

/**
 * List incursions
 * Return a list of current incursions
 */
export const getIncursions = <ThrowOnError extends boolean = false>(options: Options<GetIncursionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIncursionsResponses, GetIncursionsErrors, ThrowOnError>({
        url: '/incursions',
        ...options
    });
};

/**
 * List industry facilities
 * Return a list of industry facilities
 */
export const getIndustryFacilities = <ThrowOnError extends boolean = false>(options: Options<GetIndustryFacilitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIndustryFacilitiesResponses, GetIndustryFacilitiesErrors, ThrowOnError>({
        url: '/industry/facilities',
        ...options
    });
};

/**
 * List solar system cost indices
 * Return cost indices for solar systems
 */
export const getIndustrySystems = <ThrowOnError extends boolean = false>(options: Options<GetIndustrySystemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIndustrySystemsResponses, GetIndustrySystemsErrors, ThrowOnError>({
        url: '/industry/systems',
        ...options
    });
};

/**
 * List insurance levels
 * Return available insurance levels for all ship types
 */
export const getInsurancePrices = <ThrowOnError extends boolean = false>(options: Options<GetInsurancePricesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInsurancePricesResponses, GetInsurancePricesErrors, ThrowOnError>({
        url: '/insurance/prices',
        ...options
    });
};

/**
 * Get a single killmail
 * Return a single killmail from its ID and hash
 */
export const getKillmailsKillmailIdKillmailHash = <ThrowOnError extends boolean = false>(options: Options<GetKillmailsKillmailIdKillmailHashData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKillmailsKillmailIdKillmailHashResponses, GetKillmailsKillmailIdKillmailHashErrors, ThrowOnError>({
        url: '/killmails/{killmail_id}/{killmail_hash}',
        ...options
    });
};

/**
 * List loyalty store offers
 * Return a list of offers from a specific corporation's loyalty store
 *
 * This route expires daily at 11:05
 */
export const getLoyaltyStoresCorporationIdOffers = <ThrowOnError extends boolean = false>(options: Options<GetLoyaltyStoresCorporationIdOffersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLoyaltyStoresCorporationIdOffersResponses, GetLoyaltyStoresCorporationIdOffersErrors, ThrowOnError>({
        url: '/loyalty/stores/{corporation_id}/offers',
        ...options
    });
};

/**
 * Get item groups
 * Get a list of item groups
 *
 * This route expires daily at 11:05
 */
export const getMarketsGroups = <ThrowOnError extends boolean = false>(options: Options<GetMarketsGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsGroupsResponses, GetMarketsGroupsErrors, ThrowOnError>({
        url: '/markets/groups',
        ...options
    });
};

/**
 * Get item group information
 * Get information on an item group
 *
 * This route expires daily at 11:05
 */
export const getMarketsGroupsMarketGroupId = <ThrowOnError extends boolean = false>(options: Options<GetMarketsGroupsMarketGroupIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsGroupsMarketGroupIdResponses, GetMarketsGroupsMarketGroupIdErrors, ThrowOnError>({
        url: '/markets/groups/{market_group_id}',
        ...options
    });
};

/**
 * List market prices
 * Return a list of prices
 */
export const getMarketsPrices = <ThrowOnError extends boolean = false>(options: Options<GetMarketsPricesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsPricesResponses, GetMarketsPricesErrors, ThrowOnError>({
        url: '/markets/prices',
        ...options
    });
};

/**
 * List orders in a structure
 * Return all orders in a structure
 */
export const getMarketsStructuresStructureId = <ThrowOnError extends boolean = false>(options: Options<GetMarketsStructuresStructureIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsStructuresStructureIdResponses, GetMarketsStructuresStructureIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/markets/structures/{structure_id}',
        ...options
    });
};

/**
 * List historical market statistics in a region
 * Return a list of historical market statistics for the specified type in a region
 *
 * This route expires daily at 11:05
 */
export const getMarketsRegionIdHistory = <ThrowOnError extends boolean = false>(options: Options<GetMarketsRegionIdHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsRegionIdHistoryResponses, GetMarketsRegionIdHistoryErrors, ThrowOnError>({
        url: '/markets/{region_id}/history',
        ...options
    });
};

/**
 * List orders in a region
 * Return a list of orders in a region
 */
export const getMarketsRegionIdOrders = <ThrowOnError extends boolean = false>(options: Options<GetMarketsRegionIdOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsRegionIdOrdersResponses, GetMarketsRegionIdOrdersErrors, ThrowOnError>({
        url: '/markets/{region_id}/orders',
        ...options
    });
};

/**
 * List type IDs relevant to a market
 * Return a list of type IDs that have active orders in the region, for efficient market indexing.
 */
export const getMarketsRegionIdTypes = <ThrowOnError extends boolean = false>(options: Options<GetMarketsRegionIdTypesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketsRegionIdTypesResponses, GetMarketsRegionIdTypesErrors, ThrowOnError>({
        url: '/markets/{region_id}/types',
        ...options
    });
};

/**
 * Get route
 * Get the systems between origin and destination
 */
export const getRouteOriginDestination = <ThrowOnError extends boolean = false>(options: Options<GetRouteOriginDestinationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRouteOriginDestinationResponses, GetRouteOriginDestinationErrors, ThrowOnError>({
        url: '/route/{origin}/{destination}',
        ...options
    });
};

/**
 * List sovereignty campaigns
 * Shows sovereignty data for campaigns.
 */
export const getSovereigntyCampaigns = <ThrowOnError extends boolean = false>(options: Options<GetSovereigntyCampaignsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSovereigntyCampaignsResponses, GetSovereigntyCampaignsErrors, ThrowOnError>({
        url: '/sovereignty/campaigns',
        ...options
    });
};

/**
 * List sovereignty of systems
 * Shows sovereignty information for solar systems
 */
export const getSovereigntyMap = <ThrowOnError extends boolean = false>(options: Options<GetSovereigntyMapData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSovereigntyMapResponses, GetSovereigntyMapErrors, ThrowOnError>({
        url: '/sovereignty/map',
        ...options
    });
};

/**
 * List sovereignty structures
 * Shows sovereignty data for structures.
 */
export const getSovereigntyStructures = <ThrowOnError extends boolean = false>(options: Options<GetSovereigntyStructuresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSovereigntyStructuresResponses, GetSovereigntyStructuresErrors, ThrowOnError>({
        url: '/sovereignty/structures',
        ...options
    });
};

/**
 * Retrieve the uptime and player counts
 * EVE Server status
 */
export const getStatus = <ThrowOnError extends boolean = false>(options: Options<GetStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStatusResponses, GetStatusErrors, ThrowOnError>({
        url: '/status',
        ...options
    });
};

/**
 * Set Autopilot Waypoint
 * Set a solar system as autopilot waypoint
 */
export const postUiAutopilotWaypoint = <ThrowOnError extends boolean = false>(options: Options<PostUiAutopilotWaypointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUiAutopilotWaypointResponses, PostUiAutopilotWaypointErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/ui/autopilot/waypoint',
        ...options
    });
};

/**
 * Open Contract Window
 * Open the contract window inside the client
 */
export const postUiOpenwindowContract = <ThrowOnError extends boolean = false>(options: Options<PostUiOpenwindowContractData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUiOpenwindowContractResponses, PostUiOpenwindowContractErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/ui/openwindow/contract',
        ...options
    });
};

/**
 * Open Information Window
 * Open the information window for a character, corporation or alliance inside the client
 */
export const postUiOpenwindowInformation = <ThrowOnError extends boolean = false>(options: Options<PostUiOpenwindowInformationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUiOpenwindowInformationResponses, PostUiOpenwindowInformationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/ui/openwindow/information',
        ...options
    });
};

/**
 * Open Market Details
 * Open the market details window for a specific typeID inside the client
 */
export const postUiOpenwindowMarketdetails = <ThrowOnError extends boolean = false>(options: Options<PostUiOpenwindowMarketdetailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUiOpenwindowMarketdetailsResponses, PostUiOpenwindowMarketdetailsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/ui/openwindow/marketdetails',
        ...options
    });
};

/**
 * Open New Mail Window
 * Open the New Mail window, according to settings from the request if applicable
 */
export const postUiOpenwindowNewmail = <ThrowOnError extends boolean = false>(options: Options<PostUiOpenwindowNewmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUiOpenwindowNewmailResponses, PostUiOpenwindowNewmailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/ui/openwindow/newmail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get ancestries
 * Get all character ancestries
 *
 * This route expires daily at 11:05
 */
export const getUniverseAncestries = <ThrowOnError extends boolean = false>(options: Options<GetUniverseAncestriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseAncestriesResponses, GetUniverseAncestriesErrors, ThrowOnError>({
        url: '/universe/ancestries',
        ...options
    });
};

/**
 * Get asteroid belt information
 * Get information on an asteroid belt
 *
 * This route expires daily at 11:05
 */
export const getUniverseAsteroidBeltsAsteroidBeltId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseAsteroidBeltsAsteroidBeltIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseAsteroidBeltsAsteroidBeltIdResponses, GetUniverseAsteroidBeltsAsteroidBeltIdErrors, ThrowOnError>({
        url: '/universe/asteroid_belts/{asteroid_belt_id}',
        ...options
    });
};

/**
 * Get bloodlines
 * Get a list of bloodlines
 *
 * This route expires daily at 11:05
 */
export const getUniverseBloodlines = <ThrowOnError extends boolean = false>(options: Options<GetUniverseBloodlinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseBloodlinesResponses, GetUniverseBloodlinesErrors, ThrowOnError>({
        url: '/universe/bloodlines',
        ...options
    });
};

/**
 * Get item categories
 * Get a list of item categories
 *
 * This route expires daily at 11:05
 */
export const getUniverseCategories = <ThrowOnError extends boolean = false>(options: Options<GetUniverseCategoriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseCategoriesResponses, GetUniverseCategoriesErrors, ThrowOnError>({
        url: '/universe/categories',
        ...options
    });
};

/**
 * Get item category information
 * Get information of an item category
 *
 * This route expires daily at 11:05
 */
export const getUniverseCategoriesCategoryId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseCategoriesCategoryIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseCategoriesCategoryIdResponses, GetUniverseCategoriesCategoryIdErrors, ThrowOnError>({
        url: '/universe/categories/{category_id}',
        ...options
    });
};

/**
 * Get constellations
 * Get a list of constellations
 *
 * This route expires daily at 11:05
 */
export const getUniverseConstellations = <ThrowOnError extends boolean = false>(options: Options<GetUniverseConstellationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseConstellationsResponses, GetUniverseConstellationsErrors, ThrowOnError>({
        url: '/universe/constellations',
        ...options
    });
};

/**
 * Get constellation information
 * Get information on a constellation
 *
 * This route expires daily at 11:05
 */
export const getUniverseConstellationsConstellationId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseConstellationsConstellationIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseConstellationsConstellationIdResponses, GetUniverseConstellationsConstellationIdErrors, ThrowOnError>({
        url: '/universe/constellations/{constellation_id}',
        ...options
    });
};

/**
 * Get factions
 * Get a list of factions
 *
 * This route expires daily at 11:05
 */
export const getUniverseFactions = <ThrowOnError extends boolean = false>(options: Options<GetUniverseFactionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseFactionsResponses, GetUniverseFactionsErrors, ThrowOnError>({
        url: '/universe/factions',
        ...options
    });
};

/**
 * Get graphics
 * Get a list of graphics
 *
 * This route expires daily at 11:05
 */
export const getUniverseGraphics = <ThrowOnError extends boolean = false>(options: Options<GetUniverseGraphicsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseGraphicsResponses, GetUniverseGraphicsErrors, ThrowOnError>({
        url: '/universe/graphics',
        ...options
    });
};

/**
 * Get graphic information
 * Get information on a graphic
 *
 * This route expires daily at 11:05
 */
export const getUniverseGraphicsGraphicId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseGraphicsGraphicIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseGraphicsGraphicIdResponses, GetUniverseGraphicsGraphicIdErrors, ThrowOnError>({
        url: '/universe/graphics/{graphic_id}',
        ...options
    });
};

/**
 * Get item groups
 * Get a list of item groups
 *
 * This route expires daily at 11:05
 */
export const getUniverseGroups = <ThrowOnError extends boolean = false>(options: Options<GetUniverseGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseGroupsResponses, GetUniverseGroupsErrors, ThrowOnError>({
        url: '/universe/groups',
        ...options
    });
};

/**
 * Get item group information
 * Get information on an item group
 *
 * This route expires daily at 11:05
 */
export const getUniverseGroupsGroupId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseGroupsGroupIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseGroupsGroupIdResponses, GetUniverseGroupsGroupIdErrors, ThrowOnError>({
        url: '/universe/groups/{group_id}',
        ...options
    });
};

/**
 * Bulk names to IDs
 * Resolve a set of names to IDs in the following categories: agents, alliances, characters, constellations, corporations factions, inventory_types, regions, stations, and systems. Only exact matches will be returned. All names searched for are cached for 12 hours
 */
export const postUniverseIds = <ThrowOnError extends boolean = false>(options: Options<PostUniverseIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUniverseIdsResponses, PostUniverseIdsErrors, ThrowOnError>({
        url: '/universe/ids',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get moon information
 * Get information on a moon
 *
 * This route expires daily at 11:05
 */
export const getUniverseMoonsMoonId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseMoonsMoonIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseMoonsMoonIdResponses, GetUniverseMoonsMoonIdErrors, ThrowOnError>({
        url: '/universe/moons/{moon_id}',
        ...options
    });
};

/**
 * Get names and categories for a set of IDs
 * Resolve a set of IDs to names and categories. Supported ID's for resolving are: Characters, Corporations, Alliances, Stations, Solar Systems, Constellations, Regions, Types, Factions
 */
export const postUniverseNames = <ThrowOnError extends boolean = false>(options: Options<PostUniverseNamesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostUniverseNamesResponses, PostUniverseNamesErrors, ThrowOnError>({
        url: '/universe/names',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get planet information
 * Get information on a planet
 *
 * This route expires daily at 11:05
 */
export const getUniversePlanetsPlanetId = <ThrowOnError extends boolean = false>(options: Options<GetUniversePlanetsPlanetIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniversePlanetsPlanetIdResponses, GetUniversePlanetsPlanetIdErrors, ThrowOnError>({
        url: '/universe/planets/{planet_id}',
        ...options
    });
};

/**
 * Get character races
 * Get a list of character races
 *
 * This route expires daily at 11:05
 */
export const getUniverseRaces = <ThrowOnError extends boolean = false>(options: Options<GetUniverseRacesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseRacesResponses, GetUniverseRacesErrors, ThrowOnError>({
        url: '/universe/races',
        ...options
    });
};

/**
 * Get regions
 * Get a list of regions
 *
 * This route expires daily at 11:05
 */
export const getUniverseRegions = <ThrowOnError extends boolean = false>(options: Options<GetUniverseRegionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseRegionsResponses, GetUniverseRegionsErrors, ThrowOnError>({
        url: '/universe/regions',
        ...options
    });
};

/**
 * Get region information
 * Get information on a region
 *
 * This route expires daily at 11:05
 */
export const getUniverseRegionsRegionId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseRegionsRegionIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseRegionsRegionIdResponses, GetUniverseRegionsRegionIdErrors, ThrowOnError>({
        url: '/universe/regions/{region_id}',
        ...options
    });
};

/**
 * Get schematic information
 * Get information on a planetary factory schematic
 */
export const getUniverseSchematicsSchematicId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseSchematicsSchematicIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseSchematicsSchematicIdResponses, GetUniverseSchematicsSchematicIdErrors, ThrowOnError>({
        url: '/universe/schematics/{schematic_id}',
        ...options
    });
};

/**
 * Get stargate information
 * Get information on a stargate
 *
 * This route expires daily at 11:05
 */
export const getUniverseStargatesStargateId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseStargatesStargateIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseStargatesStargateIdResponses, GetUniverseStargatesStargateIdErrors, ThrowOnError>({
        url: '/universe/stargates/{stargate_id}',
        ...options
    });
};

/**
 * Get star information
 * Get information on a star
 *
 * This route expires daily at 11:05
 */
export const getUniverseStarsStarId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseStarsStarIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseStarsStarIdResponses, GetUniverseStarsStarIdErrors, ThrowOnError>({
        url: '/universe/stars/{star_id}',
        ...options
    });
};

/**
 * Get station information
 * Get information on a station
 *
 * This route expires daily at 11:05
 */
export const getUniverseStationsStationId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseStationsStationIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseStationsStationIdResponses, GetUniverseStationsStationIdErrors, ThrowOnError>({
        url: '/universe/stations/{station_id}',
        ...options
    });
};

/**
 * List all public structures
 * List all public structures
 */
export const getUniverseStructures = <ThrowOnError extends boolean = false>(options: Options<GetUniverseStructuresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseStructuresResponses, GetUniverseStructuresErrors, ThrowOnError>({
        url: '/universe/structures',
        ...options
    });
};

/**
 * Get structure information
 * Returns information on requested structure if you are on the ACL. Otherwise, returns "Forbidden" for all inputs.
 */
export const getUniverseStructuresStructureId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseStructuresStructureIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseStructuresStructureIdResponses, GetUniverseStructuresStructureIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/universe/structures/{structure_id}',
        ...options
    });
};

/**
 * Get system jumps
 * Get the number of jumps in solar systems within the last hour ending at the timestamp of the Last-Modified header, excluding wormhole space. Only systems with jumps will be listed
 */
export const getUniverseSystemJumps = <ThrowOnError extends boolean = false>(options: Options<GetUniverseSystemJumpsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseSystemJumpsResponses, GetUniverseSystemJumpsErrors, ThrowOnError>({
        url: '/universe/system_jumps',
        ...options
    });
};

/**
 * Get system kills
 * Get the number of ship, pod and NPC kills per solar system within the last hour ending at the timestamp of the Last-Modified header, excluding wormhole space. Only systems with kills will be listed
 */
export const getUniverseSystemKills = <ThrowOnError extends boolean = false>(options: Options<GetUniverseSystemKillsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseSystemKillsResponses, GetUniverseSystemKillsErrors, ThrowOnError>({
        url: '/universe/system_kills',
        ...options
    });
};

/**
 * Get solar systems
 * Get a list of solar systems
 *
 * This route expires daily at 11:05
 */
export const getUniverseSystems = <ThrowOnError extends boolean = false>(options: Options<GetUniverseSystemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseSystemsResponses, GetUniverseSystemsErrors, ThrowOnError>({
        url: '/universe/systems',
        ...options
    });
};

/**
 * Get solar system information
 * Get information on a solar system.
 *
 * This route expires daily at 11:05
 */
export const getUniverseSystemsSystemId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseSystemsSystemIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseSystemsSystemIdResponses, GetUniverseSystemsSystemIdErrors, ThrowOnError>({
        url: '/universe/systems/{system_id}',
        ...options
    });
};

/**
 * Get types
 * Get a list of type ids
 *
 * This route expires daily at 11:05
 */
export const getUniverseTypes = <ThrowOnError extends boolean = false>(options: Options<GetUniverseTypesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseTypesResponses, GetUniverseTypesErrors, ThrowOnError>({
        url: '/universe/types',
        ...options
    });
};

/**
 * Get type information
 * Get information on a type
 *
 * This route expires daily at 11:05
 */
export const getUniverseTypesTypeId = <ThrowOnError extends boolean = false>(options: Options<GetUniverseTypesTypeIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniverseTypesTypeIdResponses, GetUniverseTypesTypeIdErrors, ThrowOnError>({
        url: '/universe/types/{type_id}',
        ...options
    });
};

/**
 * List wars
 * Return a list of wars
 */
export const getWars = <ThrowOnError extends boolean = false>(options: Options<GetWarsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarsResponses, GetWarsErrors, ThrowOnError>({
        url: '/wars',
        ...options
    });
};

/**
 * Get war information
 * Return details about a war
 */
export const getWarsWarId = <ThrowOnError extends boolean = false>(options: Options<GetWarsWarIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarsWarIdResponses, GetWarsWarIdErrors, ThrowOnError>({
        url: '/wars/{war_id}',
        ...options
    });
};

/**
 * List kills for a war
 * Return a list of kills related to a war
 */
export const getWarsWarIdKillmails = <ThrowOnError extends boolean = false>(options: Options<GetWarsWarIdKillmailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarsWarIdKillmailsResponses, GetWarsWarIdKillmailsErrors, ThrowOnError>({
        url: '/wars/{war_id}/killmails',
        ...options
    });
};